import React, { useEffect, useState } from "react";

const API = "https://api.europeanathletic.com";

export default function Admin() {

const [competitions, setCompetitions] = useState([]);
const [classes, setClasses] = useState([]);
const [services, setServices] = useState([]);

const [selectedCompetition, setSelectedCompetition] = useState("");

const [competitionName, setCompetitionName] = useState("");
const [allowCash, setAllowCash] = useState(false);
const [isActive, setIsActive] = useState(true);

const [className, setClassName] = useState("");
const [classPrice, setClassPrice] = useState("");

const [selectedClasses, setSelectedClasses] = useState([]);

const [serviceName, setServiceName] = useState("");
const [selectedService, setSelectedService] = useState("");
const [servicePrice, setServicePrice] = useState("");

const [competitionServices, setCompetitionServices] = useState([]);

const [orders, setOrders] = useState([]);
const [showOrders, setShowOrders] = useState(false);

useEffect(() => {
loadAll();
}, []);

async function loadAll() {
await Promise.all([
loadCompetitions(),
loadClasses(),
loadServices()
]);
}

async function loadCompetitions() {
const res = await fetch(API + "/api/admin/competitions");
setCompetitions(await res.json());
}

async function loadClasses() {
const res = await fetch(API + "/api/admin/classes-list");
setClasses(await res.json());
}

async function loadServices() {
const res = await fetch(API + "/api/admin/services-list");
setServices(await res.json());
}

async function loadOrders() {

if (!selectedCompetition) {
  alert("Bitte Competition auswählen");
  return;
}

const res = await fetch(
  API + `/api/admin/orders?competition_id=${Number(selectedCompetition)}`
);

setOrders(await res.json());
setShowOrders(true);

}

async function deleteOrder(id) {

const ok = window.confirm("Bestellung wirklich löschen?");
if (!ok) return;

await fetch(API + "/api/admin/orders/" + id, {
  method: "DELETE"
});

loadOrders();

}

function exportCSV() {

if (!orders.length) {
  alert("Keine Bestellungen vorhanden");
  return;
}

const headers = [
  "Klasse",
  "Name",
  "Email",
  "Competition",
  "Status",        // 🔥 NEU
  "Zahlung",
  "Datum"
];

const rows = orders.map(o => [

  o.items || "",
  o.customer_name || "",
  o.email || "",
  o.competition_name || "",
  o.status === "PAID" ? "Bezahlt" : "Offen",  // 🔥 NEU
  o.payment_type || "",
  new Date(o.created_at).toLocaleString()
]);

const csv = [
  headers,
  ...rows
]
  .map(row => row.map(v => `"${v}"`).join(";"))
  .join("\n");

const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
const url = URL.createObjectURL(blob);

const link = document.createElement("a");
link.href = url;
link.download = "bestellungen.csv";
document.body.appendChild(link);
link.click();
document.body.removeChild(link);

}

useEffect(() => {
if (!selectedCompetition) {
setSelectedClasses([]);
setAllowCash(false);
setCompetitionServices([]);
return;
}

fetch(API + `/api/admin/competition-classes?competition_id=${selectedCompetition}`)
  .then(res => res.json())
  .then(data => {
    const ids = data.map(d => d.class_id ?? d.id);
    setSelectedClasses(ids.filter(Boolean));
  });

fetch(API + `/api/admin/competition-services?competition_id=${selectedCompetition}`)
  .then(res => res.json())
  .then(setCompetitionServices);

const comp = competitions.find(c => c.id === Number(selectedCompetition));
if (comp) {
  setAllowCash(comp.allow_cash || false);
  setCompetitionName(comp.name || "");
  setIsActive(comp.is_active ?? true);
}

}, [selectedCompetition, competitions]);

async function createCompetition() {
if (!competitionName.trim()) return;

await fetch(API + "/api/admin/competitions", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    name: competitionName,
    allow_cash: allowCash,
    is_active: isActive
  })
});

setCompetitionName("");
loadCompetitions();

}

async function updateCompetition() {

if (!selectedCompetition) {
  alert("Competition wählen");
  return;
}

await fetch(API + `/api/admin/competitions/${selectedCompetition}`, {
  method: "PUT",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    name: competitionName,
    allow_cash: allowCash,
    is_active: isActive
  })
});

alert("Competition gespeichert");
loadCompetitions();

}

async function createClass() {
if (!className.trim() || !classPrice) return;

await fetch(API + "/api/admin/classes", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    name: className.trim(),
    price: Number(classPrice)
  })
});

setClassName("");
setClassPrice("");
loadClasses();

}

async function deleteClass(id) {
const ok = window.confirm("Klasse wirklich löschen?");
if (!ok) return;

await fetch(API + "/api/admin/classes/" + id, {
  method: "DELETE"
});

setSelectedClasses(selectedClasses.filter(c => c !== id));
loadClasses();

}

function toggleClass(id) {
if (selectedClasses.includes(id)) {
setSelectedClasses(selectedClasses.filter(c => c !== id));
} else {
setSelectedClasses([...selectedClasses, id]);
}
}

async function assignClasses() {

if (!selectedCompetition) {
  alert("Competition wählen");
  return;
}

await fetch(API + "/api/admin/competition-classes", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    competition_id: Number(selectedCompetition),
    class_ids: selectedClasses
  })
});

alert("Klassen gespeichert");

}

async function createService() {
if (!serviceName.trim()) return;

await fetch(API + "/api/admin/services", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    name: serviceName.trim()
  })
});

setServiceName("");
loadServices();

}

async function assignService() {

if (!selectedCompetition || !selectedService || !servicePrice) {
  alert("Bitte alles wählen");
  return;
}

await fetch(API + "/api/admin/competition-services", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    competition_id: Number(selectedCompetition),
    service_id: Number(selectedService),
    price: Number(servicePrice)
  })
});

setServicePrice("");

fetch(API + `/api/admin/competition-services?competition_id=${selectedCompetition}`)
  .then(res => res.json())
  .then(setCompetitionServices);

}

return ( <div style={styles.container}>

  <h1>Admin Panel</h1>

  <button
    style={styles.button}
    onClick={loadOrders}
    disabled={!selectedCompetition}
  >
    📦 Bestellungen dieser Competition
  </button>

  {showOrders && (
    <div style={styles.box}>
      <h2>Bestellungen</h2>

      <button
        style={{ ...styles.button, marginBottom: 10 }}
        onClick={exportCSV}
      >
        📊 Excel Export
      </button>

      <table style={styles.table}>
        <thead>
          <tr>
            <th>Klasse</th>
            <th>Name</th>
            <th>Email</th>
            <th>Competition</th>
            <th>Status</th>
            <th>Zahlung</th>
            <th>Datum</th>
            <th>Aktion</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((o, i) => (
            <tr key={i}>
              <td>{o.items || "-"}</td>              
              <td>{o.customer_name}</td>
              <td>{o.email}</td>
              <td>{o.competition_name}</td>
              <td>
	      {o.status === "PAID" ? "✅ Bezahlt" : "⏳ Offen"}
	      </td>
	      <td>{o.payment_type}</td>
              <td>{new Date(o.created_at).toLocaleString()}</td>
              <td>
                <button
                  style={styles.delete}
                  onClick={() => deleteOrder(o.id)}
                >
                  ✕
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )}

  <div style={styles.box}>
    <h2>Competition</h2>

    <input
      style={styles.input}
      placeholder="Neue Competition"
      value={competitionName}
      onChange={e => setCompetitionName(e.target.value)}
    />

    <button style={styles.button} onClick={createCompetition}>
      Erstellen
    </button>

    <select
      style={styles.input}
      value={selectedCompetition}
      onChange={e => setSelectedCompetition(e.target.value)}
    >
      <option value="">Competition wählen</option>
      {competitions.map(c => (
        <option key={c.id} value={c.id}>{c.name}</option>
      ))}
    </select>

<button
  style={{ ...styles.button, background: "red" }}
  disabled={!selectedCompetition}
  onClick={async () => {
    const ok = window.confirm("Competition wirklich löschen?");
    if (!ok) return;

    await fetch(API + "/api/admin/competitions/" + selectedCompetition, {
      method: "DELETE"
    });

    setSelectedCompetition("");
    loadCompetitions();
  }}
>
  Competition löschen
</button>

    {selectedCompetition && (
      <>
        <label style={{ display: "flex", gap: 10 }}>
          <input
            type="checkbox"
            checked={allowCash}
            onChange={(e) => setAllowCash(e.target.checked)}
          />
          Barzahlung erlauben
        </label>

        <label style={{ display: "flex", gap: 10 }}>
          <input
            type="checkbox"
            checked={isActive}
            onChange={(e) => setIsActive(e.target.checked)}
          />
          Aktiv
        </label>

        <button style={styles.button} onClick={updateCompetition}>
          Speichern
        </button>
      </>
    )}

  </div>

  <div style={styles.box}>
    <h2>Klasse erstellen</h2>

    <input style={styles.input} placeholder="Name" value={className} onChange={e => setClassName(e.target.value)} />
    <input style={styles.input} placeholder="Preis" value={classPrice} onChange={e => setClassPrice(e.target.value)} />

    <button style={styles.button} onClick={createClass}>
      Speichern
    </button>
  </div>

  <div style={styles.box}>
    <h2>Klassen zuweisen</h2>

    <div style={{ marginBottom: 10, fontWeight: "bold" }}>
      👉 2 Klassen sind im Preis enthalten, jede weitere kostet 10€
    </div>

    {classes.map(c => (
      <div key={c.id} style={styles.card}>
        <input type="checkbox" checked={selectedClasses.includes(c.id)} onChange={() => toggleClass(c.id)} />
        {c.name} (€{c.price})
        <button style={styles.delete} onClick={() => deleteClass(c.id)}>✕</button>
      </div>
    ))}

    <button style={styles.button} onClick={assignClasses}>
      Speichern
    </button>
  </div>

  <div style={styles.box}>
    <h2>Service erstellen</h2>

    <input style={styles.input} value={serviceName} onChange={e => setServiceName(e.target.value)} />
    <button style={styles.button} onClick={createService}>
      Speichern
    </button>
  </div>

  <div style={styles.box}>
    <h2>Service zuweisen</h2>

    {competitionServices.map(s => (
      <div key={s.service_id} style={styles.card}>
        {s.name} (€{s.price})
      </div>
    ))}

    <select style={styles.input} value={selectedService} onChange={e => setSelectedService(e.target.value)}>
      <option value="">Service wählen</option>
      {services.map(s => (
        <option key={s.id} value={s.id}>{s.name}</option>
      ))}
    </select>

    <input style={styles.input} placeholder="Preis" value={servicePrice} onChange={e => setServicePrice(e.target.value)} />
    <button style={styles.button} onClick={assignService}>
      Zuweisen / Aktualisieren
    </button>
  </div>

</div>

);
}

const styles = {
container: { maxWidth: 800, margin: "auto", padding: 30 },
box: { border: "1px solid #ddd", padding: 20, marginBottom: 20 },
input: { width: "100%", padding: 10, marginBottom: 10 },
button: { width: "100%", padding: 10, marginBottom: 10, background: "black", color: "white", border: "none" },
card: { display: "flex", alignItems: "center", gap: 10, marginBottom: 5 },
delete: { background: "red", color: "white", border: "none", padding: "5px 10px", cursor: "pointer" },
table: { width: "100%", borderCollapse: "collapse" }
};
